<template>
  <div :class="$utilModalStyle.modalOverlay" @click="closeModal">
    <div :class="[$utilModalStyle.modalContent, $style.saboteursModalContent]" @click.stop>
      <h3 :class="$style.title">{{ $t('saboteurs-title') }}</h3>
      <div :class="$style.subTitle">{{ $t('saboteurs-subtitle') }}</div>
      <div :class="$style.body">
        <div :class="$style.groupsList">
          <div v-for="(group, index) in groups" :key="group.id" :class="$style.groupItem">
            <div :class="$style.groupHeader">
              <div :class="$style.groupName">{{ getGroupDisplayName(group, index, t) }}</div>
            </div>
            <div :class="$style.playerContainer">
              <img :class="$style.playerAvatar" :src="group?.saboteur?.avatar ?? defaultAvatar" alt="no saboteur" />
              <div :class="$style.playerName">
                {{ group?.saboteur?.name ?? "-- " + $t('no-saboteur') + " --" }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div :class="$utilModalStyle.modalActions">
        <!-- <button :class="$utilModalStyle.secondaryAction" @click="closeModal">I'll Wait</button> -->
        <button :class="$utilModalStyle.primaryAction" @click="props.closeModal">{{ $t('close') }}</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import styles from "@/css/SaboteursModal.module.css";
import utilModalStyles from "@/css/UtilModal.module.css";
import { defaultAvatar } from "@/utils/data";
import { getGroupDisplayName } from "@/utils/functions";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const $style = styles;
const $utilModalStyle = utilModalStyles;

// eslint-disable-next-line
const props = defineProps({
  closeModal: {
    type: Function,
    required: true,
  },
  groups: {
    type: Array,
    required: true,
  },
});
</script>

<style scoped></style>
